import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CurrencyComponent } from '../currency/currency.component';

@Component({
  selector: 'app-sip-pitch-otd',
  standalone: true,
  imports: [CommonModule, CurrencyComponent, NgOptimizedImage],
  templateUrl: './sip-pitch-otd.component.html',
  styleUrls: ['./sip-pitch-otd.component.scss']
})
export class SipPitchOtdComponent implements OnChanges {

  @Input() currency;
  @Output() onSipCheck = new EventEmitter();

  isChecked = true;
  displayAmt = 0;
  selectedAmt = 0;

  amounts = { USD: 5, GBP: 5, EUR: 5, AED: 10, SAR: 10, SGD: 10, CAD: 5, HKD: 5, QAR: 10, AUD: 5, MYR: 10 };

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['currency'] && (changes?.['currency']?.currentValue !== changes?.['currency']?.previousValue)) {
      this.setValue();
    }
  }

  onCheck() {
    this.isChecked = !this.isChecked;
    this.setValue();
  }

  setValue() {
    this.displayAmt = Object.keys(this.amounts).includes(this.currency) ? this.amounts[this.currency] : 5;
    this.selectedAmt = this.isChecked ? this.displayAmt : 0;
    this.onSipCheck.emit(this.selectedAmt);
  }
}
